import api from './api';

export const queueService = {
  list: async (params = {}) => {
    const response = await api.get('/queue', { params });
    return response.data;
  },

  board: async (centreId) => {
    const response = await api.get('/queue/board', { params: { centreId: centreId || undefined } });
    return response.data;
  },

  report: async (from, to, centreId) => {
    const response = await api.get('/queue/report', { params: { from, to, centreId: centreId || undefined } });
    return response.data;
  },

  counters: async ({ centreId, includeInactive } = {}) => {
    const response = await api.get('/queue/counters', { params: { centreId: centreId || undefined, includeInactive: includeInactive || undefined } });
    return response.data;
  },

  saveCounter: async (counter) => {
    const response = await api.post('/queue/counters', counter);
    return response.data;
  },

  issue: async (payload) => {
    const response = await api.post('/queue/issue', payload);
    return response.data;
  },

  /** data is null when nobody is waiting. */
  callNext: async (counterId) => {
    const response = await api.post('/queue/call-next', { counterId });
    return response.data;
  },

  /** action: start | complete | skip | requeue | recall (recall of a skipped token needs the counter). */
  change: async (ticketId, action, counterId) => {
    const response = await api.post(`/queue/${ticketId}/${action}`, null, { params: { counterId: counterId || undefined } });
    return response.data;
  },

  // ---- per-centre settings, display screens and the automatic token

  config: async (centreId) => {
    const response = await api.get('/queue/config', { params: { centreId: centreId || undefined } });
    return response.data;
  },

  saveConfig: async (config) => {
    const response = await api.put('/queue/config', config);
    return response.data;
  },

  displayTokens: async (centreId) => {
    const response = await api.get('/queue/display-tokens', { params: { centreId: centreId || undefined } });
    return response.data;
  },

  /** data.token is the only time the token can be read; the server keeps just its hash. */
  issueDisplayToken: async ({ label, centreId }) => {
    const response = await api.post('/queue/display-tokens', { label, centreId: centreId || undefined });
    return response.data;
  },

  revokeDisplayToken: async (displayTokenId) => {
    const response = await api.post(`/queue/display-tokens/${displayTokenId}/revoke`);
    return response.data;
  },

  rotateDisplayToken: async (displayTokenId) => {
    const response = await api.post(`/queue/display-tokens/${displayTokenId}/rotate`);
    return response.data;
  },

  /** Registrations whose automatic token could not be issued. */
  pendingAutoTokens: async (centreId) => {
    const response = await api.get('/queue/auto-token/pending', { params: { centreId: centreId || undefined } });
    return response.data;
  },

  retryAutoToken: async (labNo) => {
    const response = await api.post('/queue/auto-token/retry', { labNo });
    return response.data;
  },

  transfer: async (ticketId, nextStage, labNo) => {
    const response = await api.post(`/queue/${ticketId}/transfer`, { nextStage, labNo: labNo || undefined });
    return response.data;
  },
};

export default queueService;
